export const GYNEC_SECTION_ENABLE_LIST = {
    cycle : true,
    flow : true,
    pain : true,
    ageAtMenarche : true,
    reproductiveStages : true,
    note : true,
};

export const CYCLE_KEY_LIST = [
    { value: "Regular", label: "Regular" },
    { value: "Irregular", label: "Irregular" },
];

export const FLOW_LIST = [
    { value: "Heavy", label: "Heavy" },
    { value: "Moderate", label: "Moderate" },
    { value: "Scanty", label: "Scanty" },
];

export const PAIN_LIST = [
    { value: "None", label: "None" },
    { value: "Mild", label: "Mild" },
    { value: "Moderate", label: "Moderate" },
    { value: "Severe", label: "Severe" },
];

export const REPRODUCTIVE_LIFE_STAGES_LIST = [
    { value: "Menopause", label: "Menopause" },
    { value: "Perimenopause", label: "Perimenopause" },
    { value: "Lactational amenorrhea", label: "Lactational amenorrhea" },
];
export const TYPES_REPRODUCTIVE_STAGES = [
    { value: "Normal", label: "Normal" },
    { value: "Surgical", label: "Surgical" },
    { value: "Chemotherapy - induced", label: "Chemotherapy - induced" },
    { value: "Primary ovarian sufficiency", label: "Primary Ovarian Sufficiency" },
    { value: "Other", label: "Other" },
];
export const PAIN_OCCURANCE_LIST = [
    { value: "Before menses", label: "Before Menses" },
    { value: "During menses", label: "During Menses" },
    { value: "After menses", label: "After Menses" },
    { value: "Not related to menses", label: "Not Related to Menses" },
];
export const CLOTS_LIST = [
    { value: true, label: "Clots" },
    { value: false, label: "No clots" },
];